module.exports = __webpack_public_path__ + "img/19.54716a31.png";